import { useQuery } from "react-query";
import { statistics } from "../../api/statistics";
import moment from "moment";
import { useGlobalStore } from "../../store";

export const useFinancialMetrics = (isActive?: boolean) => {
  const selectedCompany = useGlobalStore(state => state.selectedCompany);
  return useQuery(
    ["financial-metrics", { selectedCompany, isActive }],
    () =>
      selectedCompany && statistics.financialMetrics(selectedCompany, isActive),
    {
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};
